/**
 * Форматирует число, добавляя пробелы между тысячами.
 * @param num - Число, которое нужно отформатировать.
 * @returns Строка с отформатированным числом.
 */
export function formatNumber(num) {
    num = Number(num);
    if (isNaN(num))
        return 'NaN';
    var fixed = Number(num.toFixed(2));
    var parts = fixed.toString().split('.');
    var integerPart = parts[0];
    var decimalPart = parts[1] || '00';
    var formattedInt = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return decimalPart === '00' ? formattedInt : "".concat(formattedInt, ".").concat(decimalPart);
}
